
import React from 'react';
import { TabsTrigger } from '@/components/ui/tabs';
import { Activity, FlaskConical, Lightbulb, Brain, MessageSquare } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface TabTriggersProps {
  isMobile: boolean;
}

const TabTriggers: React.FC<TabTriggersProps> = ({ isMobile }) => {
  return (
    <>
      <TabsTrigger value="dashboard" className="flex items-center justify-center gap-1 flex-1 min-w-0 px-2">
        <Activity className="h-4 w-4" />
        {!isMobile && "Period Dashboard"}
      </TabsTrigger>
      <TabsTrigger value="insights" className="flex items-center justify-center gap-1 flex-1 min-w-0 px-2">
        <Lightbulb className="h-4 w-4 text-[#9b87f5]" />
        {!isMobile && "Cycle Insights"}
        <span className="animate-pulse-soft">✨</span>
      </TabsTrigger>
      <TabsTrigger value="consultant" className="flex items-center justify-center gap-1 flex-1 min-w-0 px-2">
        <MessageSquare className="h-4 w-4 text-[#5a8bff]" />
        {!isMobile && "AI Consultant"}
        <Badge className="ml-1 text-[9px] bg-blue-500 text-white flex items-center">
          New
        </Badge>
      </TabsTrigger>
      <TabsTrigger value="testing" className="flex items-center justify-center gap-1 flex-1 min-w-0 px-2">
        <FlaskConical className="h-4 w-4" />
        {!isMobile && "Hormone Testing"}
        <Badge className="ml-1 text-[9px] bg-red-500 text-white flex items-center">
          <svg className="h-3 w-3 animate-pulse-soft" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 14l6-6"/><path d="M4 14h.01"/><path d="M12 14h.01"/><path d="M20 14h.01"/><path d="M4 21h.01"/><path d="M12 21h.01"/><path d="M20 21h.01"/>
          </svg>
        </Badge>
      </TabsTrigger>
    </>
  );
};

export default TabTriggers;
